import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { catchError, map, Observable, of, throwError } from 'rxjs'
import { eps } from './url.service'
import { ToastrService } from 'ngx-toastr'

export interface GetPaymentLinkResponse {
  paymentNeeded: boolean
  message?: string
  redirectUrl?: string
}

export interface SubscriptionInitiationResponse {
  type: 'order' | 'subscription'
  key: string
  orderId?: string
  subscriptionId?: string
  amount?: number
  currency?: string
}

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  private http = inject(HttpClient)
  private paymentsApi = eps.payments.paymentsApi
  toastr = inject(ToastrService)

  initiateAddLicences(subscriptionId: string, totalLicences: number): Observable<any> {
    return this.http.post<any>(this.paymentsApi + '/add-licences', {
      subscriptionId,
      newTotalLicences: totalLicences
    })
  }

  initiateSubscription(
    currentSubscriptionId: string,
    newPlanId: string,
    licencesCount: number
  ): Observable<SubscriptionInitiationResponse> {
    const body = { currentSubscriptionId, newPlanId, licencesCount }
    return this.http.post<SubscriptionInitiationResponse>(this.paymentsApi + '/activate-plan', body)
  }

  //Get a payment link for plan activation
  //getActivationPaymentLink(
  //  currentSubscriptionId: string,
  //  newPlanId: string,
  //  licencesCount?: number
  //): Observable<GetPaymentLinkResponse> {
  //  const payload = {
  //    currentSubscriptionId,
  //    newPlanId,
  //    licencesCount
  //  }
  //  licencesCount ? (payload.licencesCount = licencesCount) : null
  //  return this.http
  //    .post<GetPaymentLinkResponse>(this.paymentsApi + '/activate-plan', payload)
  //    .pipe(
  //      map(response => response),
  //      catchError(error => {
  //        this.toastr.error(error.error.message, 'Bad Request Error')
  //        return of(error)
  //      })
  //    )
  //}

  //Get a payment link for upgrade/degrade
  initiatePlanChange(
    currentSubscriptionId: string,
    newPlanId: string,
    licencesCount?: number
  ): Observable<any> {
    const payload = {
      currentSubscriptionId,
      newPlanId,
      licencesCount
    }
    // licencesCount ? (payload.licencesCount = licencesCount) : null
    if (licencesCount !== undefined && licencesCount !== null) {
      payload.licencesCount = licencesCount
    }
    return this.http.post<any>(this.paymentsApi + '/change-plan', payload)
  }

  //Verify a payment
  verifyRedirectPayment(paymentData: {
    razorpay_payment_id: string
    razorpay_payment_link_id: string
    razorpay_payment_link_status: string
    razorpay_payment_link_reference_id: string
    razorpay_signature: string
  }): Observable<{ status: string }> {
    return this.http.post<{ status: string }>(this.paymentsApi + '/verify', paymentData).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  //updateSalary(salary: EmployeeSalary): Observable<EmployeeSalary> {
  //  return this.http.put<EmployeeSalary>(`${this.salaryApi}`, { ...salary }).pipe(
  //    map(response => response),
  //    catchError(error => throwError(() => error))
  //  )
  //}

  //deleteSalary(id: string): Observable<{ message: string; status: string }> {
  //  return this.http
  //    .delete<{
  //      message: string
  //      status: string
  //    }>(`${this.salaryApi}/${id}`)
  //    .pipe(
  //      map(response => response),
  //      catchError(error => throwError(() => error))
  //    )
  //}

  authenticateMandate(internalSubscriptionId: string) {
    return this.http.post<{
      key: string
      subscriptionId: string
    }>(`${this.paymentsApi}/${internalSubscriptionId}/authenticate-mandate`, {})
  }
}
